import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Menu, MenuItem } from "@szhsin/react-menu";
import copy from "copy-to-clipboard";
import { isEmpty } from "lodash";

import { useHistory } from "react-router-dom";

// Assets
import profilePage from "../../assets/defaultProfile.jpg";

// Material UI Icons
import ShareIcon from "@mui/icons-material/Share";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Pages and Elements
import NFTCards from "../../components/nftCards/NFTCards";
import EditProfile from "./editProfile/EditProfile";
import Copy from "../../components/copyToClipboard/Copy";
import PreloaderInner from "./../../components/preloader/loader";
import firebase from "./../../firebase";

import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";

export default function SearchProfile() {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const menus = ["left"];
  const [display, setDisplay] = useState("arrow");
  const [align, setAlign] = useState("center");
  const [position, setPosition] = useState("anchor");
  const [viewScroll, setViewScroll] = useState("auto");
  const [user, setUser] = React.useState({});
  const [nfts, setNFts] = React.useState([]);
  const shareUrl = window.location.href;
  const { id } = useParams();

  async function fetchData() {
    await firebase
      .firestore()
      .collection("UserDataModel")
      .limit(1)
      .where("username", "==", `${id}`)
      .get()
      .then(function (querySnapshot) {
        if (querySnapshot.empty) {
          history.push("/");
        }
        querySnapshot.forEach(function (doc) {
          console.log(doc.data());
          const userDetail = doc.data();
          setUser(userDetail);
          setTimeout(() => {
            setLoading(false);
          }, 2000);
        });
      })
      .catch(function (error) {
        console.log("Error getting documents: ", error);
      });
  }

  async function fetchNFTs() {
    await firebase
      .firestore()
      .collection("NFTDataModel")
      .limit(10)
      .where("creatorAddress", "==", `${user.walletAddress}`)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach((doc) => {
          const document = doc.data();
          document.docID = doc.id;
          setNFts((prev) => [...prev, document]);
        });
      });
  }

  useEffect(() => {
    if (isEmpty(user)) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    if (!isEmpty(user)) {
      if (!nfts.length) {
        fetchNFTs();
        console.log(nfts, user);
      }
    }
  }, [user]);

  return (
    <section>
      {loading ? (
        <PreloaderInner />
      ) : (
        <>
          <div className="share-buttons">
            <button>
              {menus.map((direction) => (
                <Menu
                  menuButton={
                    <button>
                      <ShareIcon />
                      <p>Share</p>
                    </button>
                  }
                  key={direction}
                  direction={direction}
                  align={align}
                  position={position}
                  viewScroll={viewScroll}
                  arrow={display === "arrow"}
                  offsetX={
                    display === "offset" &&
                    (direction === "left" || direction === "right")
                      ? 12
                      : 0
                  }
                  offsetY={
                    display === "offset" &&
                    (direction === "top" || direction === "bottom")
                      ? 12
                      : 0
                  }
                >
                  <MenuItem onClick={(e) => copy(shareUrl)}>
                    <div className="option-container">
                      <div className="icon-box">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="size-of-icon"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                          <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                        </svg>
                      </div>
                      <div className="option-text">Copy Link</div>
                    </div>
                  </MenuItem>
                  <MenuItem>
                    <FacebookShareButton url={shareUrl} title={user.username}>
                      <div className="option-container">
                        <div className="icon-box">
                          <FacebookIcon size={"1.5rem"} />
                        </div>
                        <div className="option-text">Share on Facebook</div>
                      </div>
                    </FacebookShareButton>
                  </MenuItem>
                  <MenuItem>
                    <TwitterShareButton url={shareUrl} title={user.username}>
                      <div className="option-container">
                        <div className="icon-box">
                          <TwitterIcon size={"1.5rem"} />
                        </div>
                        <div className="option-text">Share on Twitter</div>
                      </div>
                    </TwitterShareButton>
                  </MenuItem>
                </Menu>
              ))}
            </button>
          </div>
          <div className="profile">
            <img
              src={user.imageURL ? user.imageURL : profilePage}
              alt="profile"
            />
            <h2 className="yellow">{user.name}</h2>
            <p>@{user.username}</p>

            <Copy url={user.walletAddress} />
            <div className="social-icons">
              {user.twitter ? (
                <a href="https://twitter.com/LoopGem">
                  <TwitterIcon />
                </a>
              ) : null}
              {user.instagram ? (
                <a href="https://www.instagram.com/loop_gem/">
                  <InstagramIcon />
                </a>
              ) : null}
              {user.youtube ? (
                <a href="https://www.facebook.com/loopgem/">
                  <YouTubeIcon />
                </a>
              ) : null}
            </div>
          </div>
          <br />
          <br />

          <h1 className="space-heading margin-heading">NFTs CREATED</h1>
          <NFTCards nfts={nfts} />
        </>
      )}
    </section>
  );
}
